import React, {ReactNode, FC} from "react";
import './style.scss';

interface InfoCardProps {
  title?: string,
  children?: ReactNode,
  className?: string
}

const InfoCard: FC<InfoCardProps> = ({title, className, children}) => {

  let resultingClassName = "info-card";
  if (className) resultingClassName += " " + className;

  return (
    <div className={resultingClassName}>
      {title ? <span className="title">{title}</span> : null}
      {children}
    </div>
  )
}

export default InfoCard;
